/* @flow */

import { compose } from 'ramda';
import { intlShape, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { defaultBraindateSingular } from '@braindate/domain/lib/event/setting';
import { getEventBraindateSingular } from '@braindate/domain/lib/event/util';

import MarketPromptCardDumb from './MarketPromptCardDumb';
import {
  getGuidanceText,
  getGuidanceAction,
  getGuidanceQuickStartFilterValues,
  getGuidanceQuickStartSortValue,
  guidanceQuickStart,
} from 'src/shared/app/market/guidance/settings/guidanceSettings';
import {
  setMarketKindFilter,
  setMarketSortOrdering,
  invalidateMarket,
} from 'src/shared/app/market/action/marketActions';
import { kindFilterParam } from 'src/shared/app/market/settings/marketSettings';
import { getEventSafely } from 'src/shared/domain/event/selector/eventSelectors';
import { getMembership } from 'src/shared/domain/membership/selector/membershipSelectors';
import { deleteGuidanceMarketPrompt } from 'src/shared/domain/membership/action/membershipActions';
import { trackGAEvent } from 'src/shared/core/service/tracking/gaService';

import type { State } from 'src/shared/core/type/reduxTypes';

type Props = {
  // Self passed
  intl: intlShape,
};

const mapStateToProps = (state: State, ownProps: Props): Object => {
  const event = getEventSafely(state);
  const { intl } = ownProps;

  return {
    ...ownProps,
    confirmCta: getGuidanceAction(guidanceQuickStart, intl),
    text: getGuidanceText(guidanceQuickStart, intl, {
      braindateSingular:
        getEventBraindateSingular(event, intl.locale) ||
        defaultBraindateSingular,
    }),
    // merge
    membership: getMembership(state),
  };
};

const mapDispatchToProps = (dispatch: any): Object => ({ dispatch });

const mergeProps = (stateProps: Object, { dispatch }: Object): Object => {
  const { membership } = stateProps;
  const guidanceFilterValues = getGuidanceQuickStartFilterValues();

  return {
    ...stateProps,
    onClick() {
      // $FlowIssue - We are checking if it exist first
      if (guidanceFilterValues[kindFilterParam]) {
        dispatch(setMarketKindFilter([guidanceFilterValues[kindFilterParam]]));
        dispatch(setMarketSortOrdering(getGuidanceQuickStartSortValue()));

        dispatch(invalidateMarket());
        dispatch(deleteGuidanceMarketPrompt(membership, guidanceQuickStart));

        trackGAEvent('Market', 'Click prompt', guidanceQuickStart);
      }
    },
  };
};

export default compose(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
)(MarketPromptCardDumb);
